<template>
  <label
    v-if="isVisible"
    :class="[
      $style.wrapper,
      {
        [$style.isActive]: isActive,
      },
    ]"
  >
    <span :class="$style.label">
      <slot />
    </span>
    <BaseCheckbox
      v-if="isVisible"
      v-model="modelProxy"
      v-model:isIndeterminate="isIndeterminateProxy"
      is-dark
      :class="$style.checkbox"
      :name="name"
      :value="value"
      :disabled="isDisabled"
      @change="onChange"
    />
  </label>
</template>

<script>
import BaseCheckbox from '@/components/base/Checkbox';

export default {
  components: {
    BaseCheckbox,
  },
  props: {
    name: {
      type: null,
      default: undefined,
    },
    value: {
      type: null,
      default: undefined,
    },
    modelValue: {
      type: null,
      default: undefined,
    },
    isIndeterminate: {
      type: null,
      default: false,
    },
    isDisabled: {
      type: null,
      default: false,
    },
    id: {
      type: null,
      default: undefined,
    },
    isVisible: {
      type: null,
      default: true,
    },
  },
  emits: {
    'update:modelValue': null,
    'update:isIndeterminate': null,
    change: null,
  },
  computed: {
    modelProxy: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    isIndeterminateProxy: {
      get() {
        return this.isIndeterminate;
      },
      set(value) {
        this.$emit('update:isIndeterminate', value);
      },
    },
    isActive() {
      return this.modelValue === true || this.modelValue.includes(this.value);
    },
  },
  methods: {
    onChange(e) {
      this.$emit('change', e);
    },
  },
};
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 7px 5px 10px;
  background-color: rgba($background-light, 0);
  border-radius: 5px;
  transition: background-color 0.2s ease-in-out;

  &.isActive {
    background-color: rgba($background-light, 1);

    .label {
      font-weight: 600;
      color: rgba($title, 1);
    }
  }
}

.label {
  font-size: 16px;
  color: rgba($title, 0.8);
  transition: color 0.2s ease-in-out;
}

.checkbox {
  margin-left: 10px;
}
</style>
